'use client';

import { jsx } from "react/jsx-runtime";
import { memo, forwardRef } from "react";
import { MenuItemWithSymbolsAsAnchor } from "./MenuItemWithSymbols.AsAnchor.js";
import { MenuItemWithSymbolsAsButton } from "./MenuItemWithSymbols.AsButton.js";
function MenuItemWithSymbolsComponent(props, ref) {
  if ("href" in props) {
    return /* @__PURE__ */ jsx(
      MenuItemWithSymbolsAsAnchor,
      {
        ...props,
        ref
      }
    );
  }
  return /* @__PURE__ */ jsx(
    MenuItemWithSymbolsAsButton,
    {
      ...props,
      ref
    }
  );
}
const MenuItemWithSymbols = (
  /* #__PURE_ */
  memo(
    forwardRef(MenuItemWithSymbolsComponent)
  )
);
export {
  MenuItemWithSymbols
};
